export const minRelativeDays = 2
export const maxRelativeDays = 6

export const defaultReveniDisplayName = 'Reveni'

export const changeTypes = {
  fieldUpdate: 'field_update',
  objectCreated: 'object_created',
  objectUpdated: 'object_updated',
  objectDeleted: 'object_deleted',
}

export const eventIconTypes = {
  edit: 'edit',
  plus: 'plus',
  trash: 'trash',
  upload: 'upload',
  download: 'download',
}
